import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomDeleteAiMappingDetectionMutation } from "generated/graphql";


export const useDeleteAiMappingDetection = () => {
  const [mutation, { data, loading, error }] = useCustomDeleteAiMappingDetectionMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "deleteAiMappingDetection" },
    { hideMessage: true }
  );
};
